var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('common.monitor_overview')}}),_c('page-body',[_c('overview-index')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }